import * as React from 'react';
import { Icon } from './Icon';

// "What needs attention" callout row — tinted icon chip + message + deep-link
// action. Mirrors Docs/Design Handoff/portal/common.jsx.
export interface AttnRowProps {
  icon: string;
  color: string;
  children: React.ReactNode;
  action?: string;
  onAction?: () => void;
}

export function AttnRow({ icon, color, children, action, onAction }: AttnRowProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid var(--border)' }}>
      <div style={{ width: 30, height: 30, borderRadius: 8, background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon name={icon} size={15} color={color} />
      </div>
      <div style={{ flex: 1, fontSize: 13, color: 'var(--text-primary)', lineHeight: 1.4 }}>{children}</div>
      {action && (
        <button
          type="button"
          onClick={onAction}
          style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--accent)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 3, whiteSpace: 'nowrap', fontFamily: 'inherit' }}
        >
          {action} <Icon name="arrow-right" size={12} />
        </button>
      )}
    </div>
  );
}

export default AttnRow;
